import React, { useMemo } from 'react';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { WriteBackToLeverPlaceToWrite } from 'libs/end-to-end/src/types/databases/workflows/strategies/lever-write-back';

export interface ConfigureWriteBackLeverPlaceToWriteProps {
  placeToWrite: WriteBackToLeverPlaceToWrite | null;
  updatePlaceToWrite: (
    newPlaceToWrite: WriteBackToLeverPlaceToWrite | null,
  ) => void;
}

export const ConfigureWriteBackLeverPlaceToWrite = ({
  placeToWrite,
  updatePlaceToWrite,
}: ConfigureWriteBackLeverPlaceToWriteProps) => {
  const placeTypeList = useMemo(() => {
    return [
      { optionLabel: 'None', optionValue: 'none' },
      {
        optionLabel: 'Note',
        optionValue: 'note',
      },
      {
        optionLabel: 'Tag',
        optionValue: 'tag',
      },
    ];
  }, []);
  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <label className="block text-sm font-medium text-gray-700">
        Select a place
      </label>
      <SelectBoxWithSearch
        type="single"
        list={placeTypeList}
        label="Place Type"
        selected={placeToWrite?.type ?? 'none'}
        setSelected={(
          newSelected: 'none' | WriteBackToLeverPlaceToWrite['type'],
        ) => {
          updatePlaceToWrite(
            newSelected === 'none' ? null : { type: newSelected },
          );
        }}
      />
    </div>
  );
};
